import { validator } from '@app/constant/FormConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import { formatNumber, formatPrice } from '@app/libs/format'
import getCDNImage from '@app/libs/getCDNImage'
import { InertiaLink } from '@inertiajs/inertia-react'
import { DeleteForever } from '@mui/icons-material'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const CustomContainer = styled(Grid)({
  height: '100%',
  alignContent: 'center',
  justifyContent: 'center',
})

const CustomName = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical ',
  paddingLeft: '20px',
  fontWeight: 600,
})

const CustomTextField = styled(TextField)({
  padding: '0 10px !important',
})

export default function ItemRender({ item, handleRemoveVoucher, getValues, setValue, register, watch }) {
  const { t } = useTranslation()

  const { premium } = getValues('data')

  useEffect(() => {
    getValues('data')
  }, [watch('data.premium')])

  return (
    <ListItem sx={{ backgroundColor: '#fff', borderRadius: 3 }}>
      <Grid container justifyContent="space-between">
        <Grid item xs={1.4}>
          <CustomContainer container>
            <img src={getCDNImage(item.images[0]?.link)} width="100%" />
          </CustomContainer>
        </Grid>
        <Grid item xs={1.8}>
          <CustomContainer container>
            <CustomName>{item.name}</CustomName>
          </CustomContainer>
        </Grid>
        <Grid item xs={1.4}>
          <CustomContainer container>
            <CustomName>{item.merchant_name}</CustomName>
          </CustomContainer>
        </Grid>
        <Grid item xs={1.4}>
          <CustomContainer container>
            <Typography sx={{ color: '#3f51b5' }}>{formatPrice(item.price)}</Typography>
          </CustomContainer>
        </Grid>
        <Grid item xs={1.2}>
          <CustomContainer container>
            <Typography sx={{ color: '#3f51b5' }}>{formatNumber(item.available_codes)}</Typography>
          </CustomContainer>
        </Grid>

        {0 < Object.keys(getValues('data')).length && (
          <>
            {VOUCHER_TYPE.PREMIUM === item.type ? (
              <>
                <Grid item xs={0.8}>
                  <CustomContainer container>
                    <CustomTextField
                      fullWidth
                      required
                      id="formatted-numberformat-input"
                      InputProps={{
                        inputProps: {
                          pattern: validator.negative,
                          min: 0,
                        },
                      }}
                      name={`premium.premium.${item.id}`}
                      placeholder={t('CART.POINTS')}
                      size="small"
                      type="number"
                      variant="standard"
                      {...register(`data.premium.${item.id}.points`)}
                    />
                  </CustomContainer>
                </Grid>
                <Grid item xs={1.4}>
                  <CustomContainer container>
                    <Tooltip placement="bottom-start" title={`Min: ${item.limit_min} - Max: ${item.limit_max}`}>
                      <CustomTextField
                        fullWidth
                        required
                        id="formatted-numberformat-input"
                        InputProps={{
                          inputProps: {
                            pattern: validator.negative,
                            min: item.limit_min < item.available_codes ? item.limit_min : item.available_codes,
                            max: item.limit_max > item.available_codes ? Number(item.available_codes) : item.limit_max,
                          },
                        }}
                        name={`premium.${item.id}`}
                        placeholder={`Min: ${item.limit_min} - Max: ${item.limit_max}`}
                        size="small"
                        type="number"
                        variant="standard"
                        onChange={(e) => {
                          setValue(`data.premium.${item.id}.quantityCodes`, e.target.value)
                          setValue(`data.premium.${item.id}.estimateCost`, parseInt(e.target.value || 0) * item.price)
                        }}
                      />
                    </Tooltip>
                  </CustomContainer>
                </Grid>
              </>
            ) : (
              <Grid item xs={0.8}>
                <CustomContainer container>
                  <CustomTextField
                    fullWidth
                    required
                    id="formatted-numberformat-input"
                    InputProps={{
                      inputProps: {
                        pattern: validator.negative,
                        min: 0,
                      },
                    }}
                    name={`standard.${item.id}`}
                    placeholder={t('CART.POINTS')}
                    size="small"
                    type="number"
                    variant="standard"
                    {...register(`data.standard.${item.id}.points`)}
                  />
                </CustomContainer>
              </Grid>
            )}
          </>
        )}
        {VOUCHER_TYPE.PREMIUM === item.type && (
          <Grid item xs={1.8}>
            <CustomContainer container>
              <CustomName>{formatPrice(!premium ? 0 : premium[item.id]['estimateCost'])}</CustomName>
            </CustomContainer>
          </Grid>
        )}
        <Grid item xs={0.8}>
          <CustomContainer container>
            <IconButton component={InertiaLink} href={route('partner.vouchers', item.id)}>
              <PageviewIcon />
            </IconButton>
            <IconButton aria-label="delete" onClick={() => handleRemoveVoucher(item)}>
              <DeleteForever />
            </IconButton>
          </CustomContainer>
        </Grid>
      </Grid>
    </ListItem>
  )
}
